import {
    FETCH_COMPANY_PAYMENT_OPTIONS,
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_COMPANY_PAYMENT_OPTIONS:
            return action.payload;
        default:
            return state;
    }
};
